// NOTE: dummy component to keep same structure between ps and rdl
const AccessPaywall = () => null;

export default AccessPaywall;
